module.exports = __webpack_public_path__ + "static/media/drp-what-is-pd-psychosis.9867d144.svg";